import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useHistory } from "react-router-dom";
import { isDev, getPartnerName } from "../helpers";

export default function SubmitDialog({
  isSubmitted: [isSubmitted, setIsSubmitted],
  orderID,
}) {
  const [open, setOpen] = React.useState(true);
  const history = useHistory();
  const handleClose = () => {
    // isDev || getPartnerName().toLowerCase() === "taumi"
    isDev ? history.replace(`/pay/${orderID}`) : history.replace("/history");
    setIsSubmitted(false);
  };

  const GotoHistoryDialog = (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="goto-history"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="goto-history">
        {"Bestellungen erfolgreich gesendet"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Sie haben erfolgreich bestellt. In einige Minuten bekommen Sie ein
          Email für Übersicht.
          {/* {getPartnerName().toLowerCase() === "taumi" && ( */}
          {isDev && (
            <>
              Sie dürfen <b>online</b> oder <b>vor Ort</b> bezahlen.
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );

  return <>{isSubmitted ? GotoHistoryDialog : null}</>;
}
